import type { ImgHTMLAttributes } from "react";

import type { MenuImage } from "../islands/header-menu/HeaderMenuTypes";

type MenuProductImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "srcSet" | "alt"
> & {
  image: MenuImage | null;
  sizes: string;
};

/**
 * Renders a menu product image from the Liquid-generated `image_url` src and srcset.
 */
export function MenuProductImage({ image, ...imgProps }: MenuProductImageProps) {
  if (!image) return null;

  return (
    <img
      src={image.src}
      srcSet={image.srcset || undefined}
      alt={image.alt}
      decoding="async"
      {...imgProps}
    />
  );
}

/**
 * Warms the browser cache so a menu panel paints its images instantly on open.
 * - `sizes` must match the rendered `<img>` so the same srcset candidate is picked.
 */
export function prefetchMenuImages(images: (MenuImage | null)[], sizes: string) {
  images.forEach((image) => {
    if (!image) return;
    const img = new Image();
    img.sizes = sizes;
    if (image.srcset) img.srcset = image.srcset;
    img.src = image.src;
  });
}
